import React, { useEffect, useState, useRef } from "react";
import './libroazul2026.css';
import { useTranslation } from 'react-i18next';
import PopupBooks from '../../components/popup/popupBooks22';


const Libroazul2026 = () => {
    const [t, i18n] = useTranslation("global");
    const [t2] = useTranslation("home");
    const [t3] = useTranslation("detail_blog");
    const [t4] = useTranslation("biblioteca");
    const [t5] = useTranslation("libroAzul");
    const [visible, setVisible] = useState(false);

    const [im] = useTranslation("libroBitcoin");
    const bannerImageBlanco =
        im("donde.btnaudio") === "ES"
            ? "/assets/img2026/book_cover_4.png"
            : "/assets/img2026/book_cover_4_en.png";
    const bannerImageBitcoin =
        im("donde.btnaudio") === "ES"
            ? "/assets/img2026/book_cover_1.png"
            : "/assets/img2026/bitcoin_englightment.png";


    return (
        <>
            <div class="_nghost-ng-c4013722087">
                <article aria-labelledby="book-detail-title" class="book-detail-page">
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c4098101840"><a
                        class="book-detail-page__back-link"
                        href={"/" + i18n.language + "/biblioteca"}>{t("general.back-library")}</a>
                        <div class="book-detail-page__cover"><img
                            src="/assets/img2026/book_details_image.png"
                            alt="Portada del libro Ideas que transforman negocios para cambiar al mundo" loading="eager"
                            fetchpriority="high" /></div>
                    </div>

                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3469483597">
                        <section class="book-detail-page__intro">
                            <h1 id="book-detail-title">{t2("2026.libro2")}</h1>
                        </section>
                    </div>

                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3568423662">
                        <section class="book-detail-page__content book-detail-page__content-noborder">
                            <blockquote class="book-detail-page__content-quote">
                                <p class="book-detail-page__content-quote-text">{t5("2026.frase")}</p><cite
                                    class="book-detail-page__content-quote-author">– Ricardo Salinas</cite>
                            </blockquote>
                        </section>
                    </div>
                    {/* 
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3469483597">
                        <section class="book-detail-page__intro">
                            <h1 id="book-detail-title">{t2("2026.libro2")}</h1>
                            <p class="book-detail-page__intro-quote">{t5("2026.frase")}</p>
                            <p class="book-detail-page__intro-author">– Ricardo Salinas</p>
                        </section>
                    </div>*/}
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c2131526924">
                        <section class="book-detail-page__content book-detail-page__content-noborder">
                            <p class="book-detail-page__lead">{t5("reason.i-have-always")}{t5("reason.a-entrepreneur")}</p>
                            <p class="book-detail-page__content-body">{t5("reason.throw-the-years")}{t5("reason.i-hope-it")} </p>
                        </section>
                    </div>
                    {/* 
                    <app-book-detail-coauthors  _nghost-ng-c3870541870="">
                        <section _ngcontent-ng-c3870541870="" aria-labelledby="book-coauthors-title"
                            class="book-detail-page__coauthors">
                            <h2 _ngcontent-ng-c3870541870="" id="book-coauthors-title" class="book-detail-page__coauthors-title">Mis
                                Co-autores</h2>
                            <div _ngcontent-ng-c3870541870="" class="book-detail-page__coauthors-list"><button
                                _ngcontent-ng-c3870541870="" type="button"
                                class="book-detail-page__coauthor-card book-detail-page__coauthor-card--trigger"
                                aria-label="Ver información sobre Daniel Jungen">
                                <h3 _ngcontent-ng-c3870541870="" class="book-detail-page__coauthor-name">Daniel Jungen</h3>
                                <p _ngcontent-ng-c3870541870="" class="book-detail-page__coauthor-role">Economista y jurista</p>
                            </button><button _ngcontent-ng-c3870541870="" type="button"
                                class="book-detail-page__coauthor-card book-detail-page__coauthor-card--trigger"
                                aria-label="Ver información sobre Pascal Hügli">
                                    <h3 _ngcontent-ng-c3870541870="" class="book-detail-page__coauthor-name">Pascal Hügli</h3>
                                    <p _ngcontent-ng-c3870541870="" class="book-detail-page__coauthor-role">Periodista
                                        financiero/inversionista</p>
                                </button></div>
                        </section>
                    </app-book-detail-coauthors>
                    */}
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c411527492">
                        <section aria-labelledby="book-detail-feature-title"
                            class="book-detail-feature">
                            <article class="book-detail-feature__media"><img
                                loading="lazy" class="book-detail-feature__image" src="/assets/img2026/co-author-image.png"
                                alt="Ricardo B. Salinas presentando el libro frente a una audiencia" />
                                {/* 
                                <button
                                    type="button" class="book-detail-feature__play"
                                    aria-label="Reproducir ¿Estás listo(a) para cambiar al mundo?"><img
                                        src="/assets/img2026/video_player_button.svg" alt="Boton azul" aria-hidden="true" /></button>
                                        <span
                                            aria-hidden="true" class="book-detail-feature__progress"></span>*/}
                            </article>
                            <div class="book-detail-feature__copy">
                                <h2 id="book-detail-feature-title" class="book-detail-feature__title">{t5("reason.title-reason")}</h2>
                                <ol class="book-detail-feature__list">
                                    <li class="book-detail-feature__list-item">{t5("reason.reason-one")}</li>
                                    <li class="book-detail-feature__list-item">{t5("reason.reason-two")}</li>
                                    <li class="book-detail-feature__list-item">{t5("reason.reason-three")}</li>
                                </ol><a target="_blank" class="book-detail-feature__cta boton-compra-only-desk"
                                    href="https://www.amazon.com.mx/Ideas-transforman-negocios-cambiar-mundo/dp/607596732X/ref=sr_1_1?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=K2T1OGRX0TJB&keywords=ideas+que+transforman+negocios+para+cambiar+el+mundo&qid=1697498981&s=books&sprefix=ideas+que+transforman+negocios+para+cambiar+el+mundo%2Cstripbooks%2C283&sr=1-1">{t5("header.buy")}</a>
                            </div>
                        </section>
                    </div>

                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c2882487804">
                        <section aria-label="Videos del libro" class="book-detail-video-gallery">
                            <article class="book-detail-video-gallery__card">
                                {/*<img src="/assets/img2026/book_detail_video_0.png"
                                    alt="Entrevista sobre el libro" loading="lazy" class="book-detail-video-gallery__image" />*/}
                                <video controls class="book-detail-video-gallery__image" poster="https://www.ricardosalinas.com/Content/assets/img/libronegocios/Portada-EntrevistaRS-1080p2.jpg ">
                                    <source src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/Entrevista-RS-landing.mp4" type="video/mp4" />
                                    <source src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/Entrevista-RS-landing.webm" type="video/webm" />
                                </video>
                            </article>
                            <article class="book-detail-video-gallery__card">
                                {/* <img src="/assets/img2026/book_detail_video_1.png"
                                alt="Libro abierto con fondo azul" loading="lazy" class="book-detail-video-gallery__image" />*/}
                                <video controls class="book-detail-video-gallery__image" poster="https://www.ricardosalinas.com/Content/assets/img/libros/poster-video-azul-escritorio.jpg">
                                    <source src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/IDEAS_3.mp4" type="video/mp4" />
                                    <source src="https://www.ricardosalinas.com/Content/assets/img/libronegocios/IDEAS_3.webm" type="video/webm" />
                                </video>
                            </article>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3568423662">
                        <section class="book-detail-page__content">
                            <blockquote class="book-detail-page__content-quote">
                                <p class="book-detail-page__content-quote-text">{t5("reason.quote-reason")}</p><cite
                                    class="book-detail-page__content-quote-author">– Ricardo Salinas</cite>
                            </blockquote>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3500518879">
                        <section id="buy-section" aria-labelledby="book-stores-title"
                            class="book-detail-page__stores">
                            <h2 id="book-stores-title">{t5("libraries.donde")}</h2>
                            <div class="store-row">
                                <h3>{t5("libraries.available-inprestigious")}</h3>
                                <div class="store-row__logos">
                                    <a target="_blank" rel="noreferrer" href="https://www.gandhi.com.mx/ideas-que-transforman-negocios-para-cambiar-el-mundo/p" aria-label="Ir a Gandhi">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_gandhi.png"
                                            alt="Gandhi" />
                                    </a>
                                    <a target="_blank" rel="noreferrer"
                                        href="https://porrua.mx/" aria-label="Ir a Porrúa">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_porrua.png" alt="Porrúa" />
                                    </a>
                                    <a
                                        target="_blank" rel="noreferrer" href="https://www.sanborns.com.mx/"
                                        aria-label="Ir a Sanborns">
                                        <img loading="lazy"
                                            src="/assets/img2026/logo_sandborns.png" alt="Sanborns" />
                                    </a>
                                    <a
                                        target="_blank" rel="noreferrer" href="https://www.amazon.com.mx/Ideas-transforman-negocios-cambiar-mundo/dp/607596732X/ref=sr_1_1?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=K2T1OGRX0TJB&keywords=ideas+que+transforman+negocios+para+cambiar+el+mundo&qid=1697498981&s=books&sprefix=ideas+que+transforman+negocios+para+cambiar+el+mundo%2Cstripbooks%2C283&sr=1-1"
                                        aria-label="Ir a Amazon"><img loading="lazy"
                                            src="/assets/img2026/logo_amazon.png" alt="Amazon" />
                                    </a>
                                </div>
                            </div>
                            <div class="store-row">
                                <h3>{t5("libraries.available-as-audio")}</h3>
                                <div class="store-row__logos"><a
                                    target="_blank" rel="noreferrer" href="https://www.audible.com/es_US/pd/Ideas-que-transforman-negocios-para-cambiar-al-mundo-Audiolibro/B0D9NQK7CZ?eac_link=PPRiX7CXUFl7&ref=web_search_eac_asin_1&eac_selected_type=asin&eac_selected=B0D9NQK7CZ&qid=s182U1YXeU&eac_id=141-4088558-2166039_s182U1YXeU&sr=1-1"
                                    aria-label="Ir a Audible">
                                    <img loading="lazy"
                                        src="/assets/img2026/logo_audible.png" alt="Audible" />
                                </a>
                                    <a
                                        target="_blank" rel="noreferrer" href="https://lanternaudio.com/audiobooks/"
                                        aria-label="Ir a Lantern">
                                        <img loading="lazy"
                                            src="/assets/img2026/logo_lantern.png" alt="Lantern" />
                                    </a>
                                    <a
                                        target="_blank" rel="noreferrer" href="https://www.storytel.com/mx/books/ideas-que-transforman-negocios-para-cambiar-al-mundo-2645263"
                                        aria-label="Ir a Storytel">
                                        <img loading="lazy"
                                            src="/assets/img2026/logo_storytel.png" alt="Storytel" />
                                    </a>
                                    <a
                                        target="_blank" rel="noreferrer" href="https://es.everand.com/audiobook/913088455/Ideas-que-transforman-negocios-para-cambiar-al-mundo" aria-label="Ir a Scribd">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_scribd.png"
                                            alt="Scribd" />
                                    </a>
                                    <a target="_blank" rel="noreferrer"
                                        href="https://www.kobo.com/mx/es/audiobook/ideas-que-transforman-negocios-para-cambiar-al-mundo?sid=0d67ff24-f831-4deb-b565-0ef98db34a26&ssid=D7ZPCEGA3FedJdFveUnUr&cPos=3" aria-label="Ir a Kobo">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_kobo.png"
                                            alt="Kobo" />
                                    </a>
                                    <a target="_blank" rel="noreferrer"
                                        href="https://play.google.com/store/audiobooks/details/Ricardo_B_Salinas_Ideas?id=AQAAAEDiV2wXnM&hl=es_MX&gl=US" aria-label="Ir a Google Play">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_google_play.png"
                                            alt="Google Play" />
                                    </a>
                                </div>
                            </div>
                            <div class="store-row">
                                <h3>{t5("libraries.available-as-eBook")}</h3>
                                <div class="store-row__logos"><a
                                    target="_blank" rel="noreferrer" href="https://www.amazon.com.mx/dp/B0CLGQK4ZL" aria-label="Ir a Kindle">
                                    <img
                                        loading="lazy" src="/assets/img2026/logo_kindle.png"
                                        alt="Kindle" />
                                </a>
                                    <a target="_blank" rel="noreferrer"
                                        href="https://books.apple.com/mx" aria-label="Ir a Apple Books">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_apple_books.png" alt="Apple Books" />
                                    </a>
                                    <a target="_blank" rel="noreferrer"
                                        href="https://www.kobo.com/mx/es/ebook/ideas-que-transforman-negocios-para-cambiar-al-mundo-1?sid=c2291cad-9660-40ff-9457-5f192985b288&ssid=TZBaQ1YeHpNYPdCtX6zrV&cPos=1" aria-label="Ir a Kobo">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_kobo.png"
                                            alt="Kobo" />
                                    </a>
                                    <a
                                        target="_blank" rel="noreferrer"
                                        href="https://play.google.com/store/books/details?id=ubPdEAAAQBAJ" aria-label="Ir a Google Play">
                                        <img
                                            loading="lazy" src="/assets/img2026/logo_google_play.png"
                                            alt="Google Play" />
                                    </a>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div class="_nghost-ng-c3151073329 fragmento-lib">
                        <section aria-label="Suscripción al boletín" class="blog-newsletter-cta">
                            <div class="blog-newsletter-cta__container">
                                <p class="blog-newsletter-cta__message"><span
                                    class="blog-newsletter-cta__message-desktop">{t("general.lib1")}</span><span
                                        class="blog-newsletter-cta__message-mobile">{t("general.lib2")}</span></p><button
                                            type="button" class="blog-newsletter-cta__button" onClick={() => {
                                                console.log("CLICK");
                                                setVisible(true);
                                            }}><span
                                                class="blog-newsletter-cta__button-desktop">{t("general.libbtn")}</span><span
                                                    class="blog-newsletter-cta__button-mobile">{t("general.libbtn2")}</span></button>
                            </div>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c3138913358">
                        <section aria-labelledby="book-collection-title"
                            class="book-detail-page__collection">
                            <h2 id="book-collection-title" class="book-detail-page__collection-title">
                                {t5("aslo.aslo")}</h2>
                            <div class="book-collection-list">
                                <article class="book-collection-card"><img
                                    loading="lazy" class="book-collection-card__image" src="/assets/img2026/book_cover_2.png"
                                    alt="Portada del libro Ideas que transforman sociedades para cambiar al mundo" />
                                    <div class="book-collection-card__copy">
                                        <p class="book-collection-card__author">Ricardo Salinas</p>
                                        <h3 class="book-collection-card__title">{t2("2026.libro3")}</h3>
                                        <p class="book-collection-card__summary">{t4("2026.desc3")}
                                        </p><a class="book-collection-card__link"
                                            href={"/" + i18n.language + "/LibroSociedades"}>{t2("2026.bookmore")}</a>
                                    </div>
                                </article>
                                <article class="book-collection-card"><img
                                    loading="lazy" class="book-collection-card__image" src={bannerImageBlanco}
                                    alt="Portada del libro Ideas sobre la libertad para cambiar al mundo" />
                                    <div class="book-collection-card__copy">
                                        <p class="book-collection-card__author">Ricardo Salinas</p>
                                        <h3 class="book-collection-card__title">{t2("2026.libro4")}</h3>
                                        <p class="book-collection-card__summary">{t4("2026.desc4")}
                                        </p><a class="book-collection-card__link"
                                            href={"/" + i18n.language + "/LibroLibertad"}>{t2("2026.bookmore")}</a>
                                    </div>
                                </article>
                            </div>
                        </section>
                    </div>
                    <div class="_ngcontent-ng-c4013722087 _nghost-ng-c411527492 flotante-comprar">
                        
                                <a target="_blank" class="book-detail-feature__cta"
                                    href="https://www.amazon.com.mx/Ideas-transforman-negocios-cambiar-mundo/dp/607596732X/ref=sr_1_1?__mk_es_MX=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=K2T1OGRX0TJB&keywords=ideas+que+transforman+negocios+para+cambiar+el+mundo&qid=1697498981&s=books&sprefix=ideas+que+transforman+negocios+para+cambiar+el+mundo%2Cstripbooks%2C283&sr=1-1">{t5("header.buy2")}</a>
                            
                    </div>

                </article>
            </div>

            <PopupBooks
                visible={visible}
                setVisible={setVisible}
                imgTemp="/assets/img2026/book_cover_1.png"
                titleLeft={t5("2026.registro")}
                titleRigth="..."
            />
        </>
    );
};
export default Libroazul2026;